import { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// Fa scadere automaticamente l'impersonificazione dopo X minuti di inattività (sicurezza).
// Ogni attività dell'admin "slitta" il cookie lato server (ping) e azzera il timer locale.
export function ImpersonationGuard() {
  const { user, stopImpersonation } = useAuth();
  const impersonating = !!user?.impersonating;
  const idleMin = user?.imp_idle_minutes || 20;
  const timerRef = useRef(null);
  const lastPingRef = useRef(0);

  useEffect(() => {
    if (!impersonating) return;
    const timeoutMs = Math.max(30, idleMin * 60 - 30) * 1000;

    const expire = async () => {
      try { await stopImpersonation(); } catch {}
      toast.info("Impersonificazione terminata per inattività.");
      window.location.assign("/app");
    };

    const reset = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(expire, timeoutMs);
      const now = Date.now();
      if (now - lastPingRef.current > 60000) {
        lastPingRef.current = now;
        api.post("/admin/impersonation/ping").catch(() => {});
      }
    };

    const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "click"];
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => {
      events.forEach((e) => window.removeEventListener(e, reset));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [impersonating, idleMin]); // eslint-disable-line

  return null;
}
